import { Component, Input } from '@angular/core';
import { OrderOutput } from 'core/http/project';

@Component({
  selector: 'app-order-id',
  templateUrl: './order-id.component.html',
  styleUrls: ['order-id.component.scss']
})
export class OrderIdComponent {

  private _order?: OrderOutput;

  @Input() link = Array<string>();
  @Input() skeletonView = false;

  @Input()
  set order(o: OrderOutput) {
    this._order = o;
  }

  get order(): OrderOutput {
    if (!this._order) {
      throw new Error('Order is not initialized');
    }

    return this._order;
  }

}
